var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07446 22.9916L19.9551 7.11098L29.1831 16.3389L13.3024 32.2196L4.07446 22.9916Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8405 22.458C16.3885 25.0059 16.3885 29.137 13.8405 31.685C11.2926 34.233 7.16149 34.233 4.61352 31.685C2.06554 29.137 2.06554 25.0059 4.61352 22.458C7.16149 19.91 11.2926 19.91 13.8405 22.458Z",
    fill: "#410BF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1816 7.11176C31.7296 9.65974 31.7296 13.7908 29.1816 16.3388C26.6336 18.8868 22.5026 18.8868 19.9546 16.3388C17.4066 13.7908 17.4066 9.65974 19.9546 7.11176C22.5026 4.56379 26.6336 4.56379 29.1816 7.11176Z",
    fill: "#8EE267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f949814.svg";
export { ForwardRef as ReactComponent };